import React from 'react';
import moment from 'moment';

const ProgressOnTable = ({ rowData }) => {
  const difference = rowData.difference;
  const currentMonth = Math.abs(parseFloat(rowData.current_month));
  const lastDateOfTheMonth = Number(moment().endOf('month').format('DD'));
  const currentDate = Number(moment().format('DD'));
  let className;
  let percentage;
  let progressTemplate;
  if (rowData.last_month !== undefined) {
    const lastMonth = Math.abs(parseFloat(rowData.last_month));
    const valueTillToday = currentDate * (lastMonth / lastDateOfTheMonth);
    if (currentMonth === 0) {
      percentage = 0;
    } else if (lastMonth === 0) {
      percentage = 101;
    } else {
      percentage = Math.round((currentMonth * 100) / lastMonth);
    }

    if (currentMonth > lastMonth) {
      className = 'progress-bar progress-bar-danger';
    } else if (currentMonth <= valueTillToday) {
      className = 'progress-bar progress-bar-success';
    } else {
      className = 'progress-bar progress-bar-warning';
    }
  }
  if (rowData.target_amount === 0) {
    className = 'progress-bar progress-bar-striped';
    percentage = 100;
  } else if (rowData.target_amount) {
    const target_amount = parseFloat(rowData.target_amount);
    const valueTillToday = currentDate * (target_amount / lastDateOfTheMonth);
    if (difference) {
      percentage = Math.round((currentMonth * 100) / target_amount);
    } else {
      percentage = null;
    }

    if (!percentage) {
      className = 'progress-bar progress-bar-striped';
    } else if (currentMonth > target_amount) {
      className = 'progress-bar progress-bar-danger';
    } else if (currentMonth <= valueTillToday) {
      className = 'progress-bar progress-bar-success';
    } else {
      className = 'progress-bar progress-bar-warning';
    }
  }

  if (!percentage) {
    percentage = 0;
  } else if (percentage >= 100) {
    percentage = 100;
  }
  if (rowData.name === 'Untagged') {
    progressTemplate = '';
  } else {
    progressTemplate = (
      <div className="progress">
        <div
          className={className}
          role="progressbar"
          aria-valuenow="45"
          aria-valuemin="0"
          aria-valuemax="100"
          style={{ width: `${percentage}%` }}
        >
          <span className="sr-only">45% Complete</span>
        </div>
      </div>
    );
  }
  return <div>{progressTemplate}</div>;
};

export default ProgressOnTable;
